import React, { useState } from 'react';
import { Button, Col, Row, Modal } from 'react-bootstrap';

import { ConnectedPatientSearch, RequestAddPatient, ResourceContent, SearchInputWithGqlDisplay } from '.';
import { PatientRequestViewModelFragment } from '../graphql';
import { getConfigurationDataKey } from '../utils';

interface AddPatientFormProps {
  defaultPatient?: PatientRequestViewModelFragment;
  onPatientSelect: (patient: PatientRequestViewModelFragment) => void;
  setDefaultPrescriber?: any;
  setDefaultLocation?: any;
  isDisabled?: boolean;
}

export const AddPatientForm = (props: AddPatientFormProps) => {
  const [isShown, setShown] = useState<boolean>(false);
  const [selectedPatient, setSelectedPatient] = useState<PatientRequestViewModelFragment | undefined>(
    props.defaultPatient
  );

  const onPatientSelect = (patient: PatientRequestViewModelFragment) => {
    props?.setDefaultPrescriber(null);
    props?.setDefaultLocation(null);
    props.onPatientSelect(patient);
    setSelectedPatient(patient);
  };

  const defaultSelected = props.defaultPatient ? [props.defaultPatient] : [];
  const closeModal = () => setShown(false);

  return (
    <Row>
      <Col className='mb-3'>
        <Row>
          <Col className='w-75 nr-patient'>
            <ResourceContent
              contentKey={getConfigurationDataKey('requests.new.patient.search.placeholder')}
              render={({ content: placeholder }) => (
                <ConnectedPatientSearch
                  asyncTypeaheadProps={{
                    defaultSelected,
                    inputProps: { 'data-testid': 'cmx__add-patient__search' }
                  }}
                  display={SearchInputWithGqlDisplay.outlined}
                  placeholder={placeholder}
                  onPatientSelect={onPatientSelect}
                  isDisabled={props?.isDisabled}
                  npiInfoSearch=''
                />
              )}
            />
          </Col>
          <Col>
            <ResourceContent
              contentKey={[
                getConfigurationDataKey('requests.new.patient.button.add'),
                'requests.new.patient.button.cancel'
              ]}
              render={([{ content: addButtonLabel = '' }, { content: cancelButtonLabel = '' }]) => (
                <Button
                  className='text-nowrap py-1 my-auto ml-2 h-100'
                  variant='outline-secondary-new'
                  disabled={!!selectedPatient}
                  onClick={() => setShown(!isShown)}
                  data-testid='cmx__add-patient__button'>
                  <i className={isShown ? '' : 'fa-light fa-user-injured'} style={{ marginRight: '8px' }}></i>
                  {isShown ? cancelButtonLabel : addButtonLabel}
                </Button>
              )}
            />
          </Col>
        </Row>
      </Col>

      <Modal show={isShown} onHide={closeModal} centered size='xl'>
        <Modal.Header closeButton>
          <div className='d-flex w-100 align-items-center justify-content-between'>
            <Modal.Title as='h5'>Add New Patient</Modal.Title>
          </div>
        </Modal.Header>
        <Modal.Body>
          {!selectedPatient && (
            <div className='bg-light-gray py-2 px-2 my-4'>
              <RequestAddPatient setShown={closeModal} setServiceAddPatientView={true} />
            </div>
          )}
        </Modal.Body>
      </Modal>
    </Row>
  );
};
